import * as React from "react";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";

const columns = [
  { id: "number", label: "#", minWidth: 80 },
  { id: "serialNumber", label: "الرقم", minWidth: 170 },
  { id: "status", label: "الحالة", minWidth: 60 },
  { id: "dateAdded", label: "الدخول", minWidth: 60 },
  { id: "dateRemoved", label: "الخروج", minWidth: 60 },
  { id: "date", label: "الانتاج", minWidth: 60 },
  {
    id: "boxWeight",
    label: "وزن الكرتون",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "bagWeight",
    label: "وزن الكيس",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "numOfBags",
    label: "عدد الأكياس",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "datesType",
    label: "نوع التمر",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "datesGrade",
    label: "نجمة",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "extraLabel",
    label: "رمز",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
  {
    id: "datesWash",
    label: "غسلة",
    minWidth: 60,
    align: "right",
    format: (value) => value.toLocaleString("en-US"),
  },
];

function createData(
  number,
  serialNumber,
  status,
  dateAdded,
  dateRemoved,
  date,
  boxWeight,
  bagWeight,
  numOfBags,
  datesType,
  datesGrade,
  extraLabel,
  datesWash
) {

  status = status? "في المخزن" : "خارج المخزن";
  dateRemoved = dateRemoved? dateRemoved : "-";
  return {
    number,
    serialNumber,
    status,
    dateAdded,
    dateRemoved,
    date,
    boxWeight,
    bagWeight,
    numOfBags,
    datesType,
    datesGrade,
    extraLabel,
    datesWash,
  };
}

/* var num = 1;
const rows = [
  createData(num++, 1000001, 2206, 20, 1, 20),
  createData(num++, 1000002, 2006, 0.5, 0.5, 1),
]; */

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

function compareValues(firstValue, secondValue) {
  if (firstValue == null) return secondValue == null ? 0 : -1;
  if (secondValue == null) return 1;

  if (typeof firstValue === "number" && typeof secondValue === "number") {
    return firstValue - secondValue;
  }

  return String(firstValue).localeCompare(String(secondValue), ["ar", "en"], {
    numeric: true,
    sensitivity: "base",
  });
}

function SortableStatsTable({ stats }) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("number");

  var num = 1;
  let rows = [];
  console.log("boxes data: ");
  stats.boxes.forEach((element) => {
    /*console.log(
      `${num}, ${element.serialNumber}, ${element.date}, ${element.boxWeight}, 
      ${element.bagWeight}, ${element.numOfBags}, 
      ${element.datesType}, ${element.datesGrade}, ${element.datesWash}`
    );*/
    rows.push(
      createData(
        num++,
        element.serialNumber,
        element.inStock,
        element.dateAdded,
        element.dateRemoved,
        element.date,
        element.boxWeight,
        element.bagWeight,
        element.numOfBags,
        element.datesType,
        element.datesGrade,
        element.extraLabel || ".",
        element.datesWash
      )
    );
  });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleRequestSort = (columnId) => {
    const isAscending = orderBy === columnId && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(columnId);
    setPage(0);
  };

  const sortedRows = rows
    .map((row, index) => ({ row, index }))
    .sort((first, second) => {
      const comparison = compareValues(
        first.row[orderBy],
        second.row[orderBy]
      );
      return comparison === 0
        ? first.index - second.index
        : order === "asc"
        ? comparison
        : -comparison;
    })
    .map(({ row }) => row);

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer sx={{ maxHeight: 440 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <StyledTableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  <TableSortLabel
                    active={orderBy === column.id}
                    direction={orderBy === column.id ? order : "asc"}
                    onClick={() => handleRequestSort(column.id)}
                    sx={{
                      color: "inherit !important",
                      "&:hover, &:focus, &.Mui-active": {
                        color: "inherit !important",
                      },
                      "& .MuiTableSortLabel-icon": {
                        color: "inherit !important",
                      },
                      "& .MuiTableSortLabel-iconDirectionAsc": {
                        transform: "rotate(0deg)",
                      },
                      "& .MuiTableSortLabel-iconDirectionDesc": {
                        transform: "rotate(180deg)",
                      },
                    }}
                  >
                    {column.label}
                  </TableSortLabel>
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedRows
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, rowIndex) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {columns.map((column) => {
                      const value =
                        column.id === "number"
                          ? page * rowsPerPage + rowIndex + 1
                          : row[column.id];
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
}

export default SortableStatsTable;
